import { render } from "./Eventos.vue?vue&type=template&id=b5a76eb8"
import script from "./Eventos.vue?vue&type=script&lang=js"
export * from "./Eventos.vue?vue&type=script&lang=js"

import exportComponent from "/srv/repos/ayuda/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__